import { UserInfoType } from 'api/auth'
import { ChangeUserEmail, CreateUserRequest } from 'api/punchlist/users/types'
import {
  FetchUserHeadParams,
  ResetPasswordPayload,
  UpdateUserListPayload,
  UserActions,
  UserType,
  userTypes,
  UserValue,
  UserValues
} from './types'

const actions = {
  fetchCurrentUser: (
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.FETCH_CURRENT_USER,
    payload: null,
    callback
  }),
  createUser: (
    payload: any,
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.CREATE_USER,
    payload,
    callback
  }),
  updateUser: (
    payload: Partial<UserType>,
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.UPDATE_USER,
    payload,
    callback
  }),
  updateUserList: (
    payload: UpdateUserListPayload,
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.UPDATE_USER_LIST,
    payload,
    callback
  }),
  setUserValue: (payload: UserValue): UserActions => ({
    type: userTypes.SET_VALUE,
    payload
  }),
  setUserValues: (payload: UserValues): UserActions => ({
    type: userTypes.SET_VALUES,
    payload
  }),
  fetchUserHead: (
    payload: FetchUserHeadParams,
    callback?: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.FETCH_USER_HEAD,
    payload,
    callback
  }),
  getUserInfo: (
    payload: null,
    callback: (succ: boolean, userInfo?: UserInfoType) => void
  ): UserActions => ({
    type: userTypes.GET_USER_INFO,
    payload: null,
    callback
  }),
  sendVerificationEmail: (
    payload: {
      userEmail: string,
      auth0AppId: string
    },
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.SEND_VERIFICATION_EMAIL,
    payload,
    callback
  }),
  sendSetPasswordEmail: (
    payload: {
      userEmail: string,
      auth0Id: string
    },
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.SEND_SET_PASSWORD_EMAIL,
    payload,
    callback
  }),
  changeUserEmail: (
    payload: ChangeUserEmail,
    callback: (succ: boolean, errorCode?: string) => void
  ): UserActions => ({
    type: userTypes.CHANGE_USER_EMAIL,
    payload,
    callback
  }),
  resetPasswordRequest: (
    payload: ResetPasswordPayload,
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.RESET_PASSWORD_REQUEST,
    payload,
    callback
  }),
  newCreateUser: (
    payload: CreateUserRequest,
    callback: (succ: boolean) => void
  ): UserActions => ({
    type: userTypes.NEW_CREATE_USER,
    payload,
    callback
  })
}

export default actions
